import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
const BASE = '/glovo/sistersflowers';

export const ensureTokens = async ({ plateformId, forceLogin = false, forceRefresh = false }) => {
  const res = await axios.post(
    `${API_URL}${BASE}/tokens`,
    { plateformId, forceLogin, forceRefresh },
    header()
  );
  return res.data;
};

export const testConnection = async ({ plateformId } = {}) => {
  const res = await axios.post(
    `${API_URL}${BASE}/test`,
    { plateformId },
    header()
  );
  return res.data;
};

export const syncCategories = async ({ plateformId, vendorId, globalEntityId = 'GV_MA', storeId = null }) => {
  const res = await axios.post(
    `${API_URL}${BASE}/categories/sync`,
    { plateformId, vendorId, globalEntityId, storeId },
    header()
  );
  return res.data;
};

export const syncProductsByCategory = async ({ plateformId, vendorId, categoryId, globalEntityId = 'GV_MA', storeCode = null, catalogId = null }) => {
  const res = await axios.post(
    `${API_URL}${BASE}/products/category/sync`,
    { plateformId, vendorId, categoryId, globalEntityId, storeCode, catalogId },
    header()
  );
  return res.data;
};

export const getProductsByCategory = async ({ plateformId, vendorId, catalogId, categoryId, globalEntityId = 'GV_MA' }) => {
  const res = await axios.post(
    `${API_URL}${BASE}/products/category`,
    { plateformId, vendorId, catalogId, categoryId, globalEntityId },
    header()
  );
  return res.data;
};

export const toggleProduct = async ({ product_id, productId, product_id_legacy, store_ids, availability }) => {
  const res = await axios.post(
    `${API_URL}${BASE}/toggle-product`,
    { product_id: product_id || productId || product_id_legacy, store_ids, availability },
    header()
  );
  return res.data;
};

export const uploadImage = async ({ plateformId, vendorId, image, globalEntityId = 'GV_MA', itemType = 'PRODUCT' }) => {
  const formData = new FormData();
  if (plateformId) formData.append('plateformId', plateformId);
  if (vendorId) formData.append('vendorId', vendorId);
  formData.append('globalEntityId', globalEntityId);
  formData.append('itemType', itemType);
  formData.append('image', image);

  const res = await axios.post(
    `${API_URL}${BASE}/upload-image`,
    formData,
    {
      ...header(),
      headers: {
        ...header().headers,
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return res.data;
};

export const createProduct = async ({ plateformId, vendorId, productData, globalEntityId = 'GV_MA', productId = null, product_id = null }) => {
  const res = await axios.post(
    `${API_URL}${BASE}/products/create`,
    { plateformId, vendorId, productData, globalEntityId, productId, product_id },
    header()
  );
  return res.data;
};

export const fetchAndUpdateProduct = async ({ plateformId, remote_id, vendorId, globalEntityId = 'GV_MA' }) => {
  const res = await axios.post(
    `${API_URL}${BASE}/products/fetch-update`,
    { plateformId, remote_id, vendorId, globalEntityId },
    header()
  );
  return res.data;
};

export default {
  ensureTokens,
  testConnection,
  syncCategories,
  syncProductsByCategory,
  toggleProduct,
  uploadImage,
  createProduct,
  fetchAndUpdateProduct
};
